
import UserList from "./list";


if (document.body.getAttribute("data-current-path") === "settings/users") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new UserList();
    }
}